// redux
import { useSelector } from "react-redux";
// mui
import { Box } from "@mui/material";
// components
import StatisticsCard from "../../components/cards/StatisticsCard";
import PageWrapper from "../../components/page/PageWrapper";
import PageTitle from "../../components/page/PageTitle";
// fetching
import fetching from "../../helpers/fetching/fetching";
import { useQuery } from "@tanstack/react-query";
// components
import ThreeDotsLoader from "../../components/loader/ThreeDotsLoader";
import ErrorSection from "../../components/alerts/ErrorSection";
// icons
import { FaRegUser } from "react-icons/fa6";
import { PiCoinsLight, PiHandCoins } from "react-icons/pi";
import { MdOutlineQuiz, MdQuiz } from "react-icons/md";
import { TbCurrencyDollar } from "react-icons/tb";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
// types
import { UserState } from "../../types/types";

const randomDarkColors: string[] = [
  "#F94144",
  "#F3722C",
  "#F8961E",
  "#F9844A",
  "#F9C74F",
  "#90BE6D",
  "#43AA8B",
  "#4D908E",
  "#577590",
  "#277DA1",
];
type Stats = {
  total_users: number;
  total_available_points: number;
  total_consumed_points: number;
  total_available_exams: number;
  total_completed_exams: number;
  total_teachers: number;
  total_charged_balance: number;
};
const Home = () => {
  const userToken = useSelector((state: UserState) => state.user.userToken);
  const fetchStatistics = () => {
    return fetching(`/statistics`, userToken)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) throw data;
        return data;
      });
  };
  const { data, isLoading, isError, error } = useQuery<
    {
      query: Record<string, string>;
    } & Stats
  >({
    queryKey: ["statistics"],
    queryFn: fetchStatistics,
  });
  return (
    <PageWrapper withBg={false}>
      <PageTitle title="الرئيسية" />
      {isLoading ? (
        <ThreeDotsLoader />
      ) : isError ? (
        <ErrorSection
          errorMsg={error?.message || error.toString() || "Error"}
        />
      ) : (
        <Box
          sx={{
            gap: "12px",
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1,1fr)",
              sm: "repeat(2,1fr)",
              lg: "repeat(3,1fr)",
            },
          }}
        >
          <StatisticsCard
            title="عدد المستخدمين"
            value={data?.total_users || 0}
            Icon={FaRegUser}
            color={randomDarkColors[0]}
          />
          <StatisticsCard
            title="عدد النقاط المتاحة"
            value={data?.total_available_points || 0}
            Icon={PiCoinsLight}
            color={randomDarkColors[1]}
          />
          <StatisticsCard
            title="عدد الامتحانات المتاحة"
            value={data?.total_available_exams || 0}
            Icon={MdOutlineQuiz}
            color={randomDarkColors[2]}
          />
          <StatisticsCard
            title="اجمالي الرصيد المشحون"
            value={data?.total_charged_balance || 0}
            Icon={TbCurrencyDollar}
            color={randomDarkColors[3]}
          />
          <StatisticsCard
            title="اجمالي الامتحانات المنجزة"
            value={data?.total_completed_exams || 0}
            Icon={MdQuiz}
            color={randomDarkColors[4]}
          />
          <StatisticsCard
            title="اجمالي النقاط المستهلكة"
            value={data?.total_consumed_points || 0}
            Icon={PiHandCoins}
            color={randomDarkColors[5]}
          />
          <StatisticsCard
            title="عدد الاساتذة"
            value={data?.total_teachers || 0}
            Icon={LiaChalkboardTeacherSolid}
            color={randomDarkColors[6]}
          />
        </Box>
      )}
    </PageWrapper>
  );
};
export default Home;
